import { useEffect } from 'react'
import PageHeader from '@/components/layout/PageHeader'
import AppearanceCard from '@/components/settings/AppearanceCard'
import ConcurrencyCard from '@/components/settings/ConcurrencyCard'
import SystemStatusCard from '@/components/settings/SystemStatusCard'
import { useSettingsStore } from '@/stores/useSettingsStore'

export default function SettingsPage(): React.ReactElement {
  const load = useSettingsStore((state) => state.load)

  useEffect(() => {
    void load()
  }, [load])

  return (
    <div className="mx-auto w-full max-w-3xl">
      <PageHeader
        title="Settings"
        description="Preferences for your account, and the health of the services this instance shares between everyone."
      />

      <div className="space-y-6">
        <AppearanceCard />
        <ConcurrencyCard />
        <SystemStatusCard />
      </div>
    </div>
  )
}

export { SettingsPage }
